import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  evidenceCard: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  evidenceTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  evidenceDescription: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  evidenceSectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
